import { Avatar } from 'antd';
import { StarFilled } from '@ant-design/icons';

export const GetSidebarMenu = (currentUser, auction, counts) => {
    const isAuctionOwner = currentUser?.id === auction?.user_id;
    
    if (isAuctionOwner) {
        return [
            { 
                key: 'all', 
                label: 'All Lots', 
                icon: null, 
                count: counts.total || 0
            },
            { 
                key: 'favorite', 
                label: 'Favorite Lots', 
                icon: <StarFilled style={{ color: '#faad14' }} />, 
                count: counts.favorite || 0
            },
            { 
                key: 'sold', 
                label: 'Sold Lots', 
                icon: <Avatar style={{ background: '#52c41a', color: '#fff' }} size={18}>S</Avatar>, 
                count: counts.sold || 0
            },
            { 
                key: 'cancelled', 
                label: 'Cancelled Lots', 
                icon: <Avatar style={{ background: '#722ed1', color: '#fff' }} size={18}>C</Avatar>, 
                count: counts.cancelled || 0
            },
            { 
                key: 'timeout', 
                label: 'Timed Out Lots', 
                icon: <Avatar style={{ background: '#fa8c16', color: '#fff' }} size={18}>T</Avatar>, 
                count: counts.timeout || 0
            }
        ];
    }

    return [
        { 
            key: 'all', 
            label: 'All Lots', 
            icon: null, 
            count: counts.total || 0
        },
        { 
            key: 'favorite', 
            label: 'Favorite Lots', 
            icon: <StarFilled style={{ color: '#faad14' }} />, 
            count: counts.favorite || 0
        },
        { 
            key: 'actively_bidding', 
            label: 'Actively Bidding', 
            icon: <Avatar style={{ background: '#1890ff', color: '#fff' }} size={18}>A</Avatar>, 
            count: counts.actively_bidding || 0
        },
        { 
            key: 'held', 
            label: 'My Held Lots', 
            icon: <Avatar style={{ background: '#1890ff' }} size={18}>H</Avatar>, 
            count: counts.held || 0
        },
        { 
            key: 'lost', 
            label: 'My Lost Lots', 
            icon: <Avatar style={{ background: '#f5222d' }} size={18}>L</Avatar>, 
            count: counts.lost || 0
        },
        { 
            key: 'cancelled', 
            label: 'Cancelled Lots', 
            icon: <Avatar style={{ background: '#722ed1' }} size={18}>C</Avatar>, 
            count: counts.cancelled || 0
        },
        { 
            key: 'timeout', 
            label: 'Timed Out Lots', 
            icon: <Avatar style={{ background: '#fa8c16' }} size={18}>T</Avatar>, 
            count: counts.timeout || 0
        }
    ];
};